/**
 * 
 * @param amount 
 * @returns number with 2 decimal places as 13.45
 */
export const formatMoney = (amount: number) => {
    return amount.toFixed(2);
};